import { BaseFetch } from "../main-model"
export default class ReportSchoolBudgetModel extends BaseFetch {
    getReportSchoolBugetBy = (data) =>
    this.authFetch({
      url: "report-school-buget/getReportSchoolBugetBy",
      method: "POST",
      body: JSON.stringify(data),
    })
}
